import { createContext, useContext } from "react";
import type { Deck } from "@deckloom/core/schema";

export interface PlayerContextValue {
  deck: Deck;
  /** URL for a static media object (images) */
  mediaUrl: (mediaId: string) => string;
  /** URL for a playable media object (video/audio with Range support) */
  playUrl: (mediaId: string) => string;
}

export const PlayerContext = createContext<PlayerContextValue | null>(null);

export function usePlayer(): PlayerContextValue {
  const v = useContext(PlayerContext);
  if (!v) throw new Error("PlayerContext missing");
  return v;
}
